import Vue from "vue";
import Router from "vue-router";

// 公共
const NotFound = () => import("@/pages/404.vue");
const Login = () => import("@/pages/Login");
const DemoTest = () => import("@/components/DemoTest");
const Layout = () => import("@/layouts/index");

// 首页
const Workbench = () => import("@/pages/home/workbench");
const Home = () => import("@/pages/home/index");

const WhiteList = () => import("@/pages/ccb/whiteList");
const RecordList = () => import("@/pages/ccb/recordList");

const QiyeEnter = () => import("@/pages/qiye/enter");
const QiyeEnterDone = () => import("@/pages/qiye/enterDone");
const QiyeEnterDownload = () => import("@/pages/qiye/download");
Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/",
            // name: 'home',
            component: Home,
            name: "home",
            meta: {
                title: "首页",
            },
        },
        {
            path: "/home",
            hidden: true,
            redirect: {
                path: "/home",
            },
        },
        {
            path: "/whiteList",
            name: "whiteList",
            component: WhiteList,
            meta: {
                title: "营销赠送客户端",
            },
        },
        {
            path: "/recordList",
            name: "recordList",
            component: RecordList,
            meta: {
                title: "营销赠送客户端",
            },
        },
        {
            path: "/enter",
            name: "qiyeenter",
            component: QiyeEnter,
            meta: {
                title: "企业入驻申请",
            },
        },
        {
            path: "/enterdone",
            name: "QiyeEnterDone",
            component: QiyeEnterDone,
            meta: {
                title: "企业入驻申请",
            },
        },
        {
            path: "/download",
            name: "QiyeEnterDownload",
            component: QiyeEnterDownload,
            meta: {
                title: "申请表管理",
            },
        },
        {
            path: "/login",
            name: "Login",
            component: Login,
            meta: {
                title: "营销赠送客户端",
            },
        },
        {
            path: "*",
            hidden: true,
            redirect: {
                path: "/404",
            },
        },
        // {
        //   path: "/404",
        //   component: NotFound,
        //   name: "",
        //   hidden: true
        // }
    ],
});
